module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "artist"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.artist.FullName,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('large-picture', {
    attrs: {
      "src": _vm.artist.picture,
      "alt": _vm.artist.name
    }
  }), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('encyclopedia.info'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "birthday"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('artist.birth')))]), _vm._v(" "), (_vm.artist.birthday !== '0000') ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.$d(new Date(_vm.artist.birthday), 'long')))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.country')))]), _vm._v(" "), (_vm.artist.country) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.artist.country))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "region"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.region')))]), _vm._v(" "), (_vm.artist.region) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.artist.region))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.city')))]), _vm._v(" "), (_vm.artist.city) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.artist.city))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])])])], 1), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$tc('artist.bands', _vm.artist.bands.length),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _vm._l((_vm.artist.bands), function(band) {
    return _c('router-link', {
      key: band.id,
      staticClass: "info bands",
      attrs: {
        "to": {
          name: 'band',
          params: {
            id: band.id
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(band.name) + "\n    ")])
  })], 2), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4068c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Artist.vue
// module id = 246
// module chunks = 0